module.exports = __webpack_public_path__ + "static/img/amex.6bc1674.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/amex.jpg
// module id = OU38
// module chunks = 6